/* eslint-disable max-lines */
import { useUser } from '../contexts/user-profile';
import { hasPermission } from './utils';

export function useCanAddAlarmComment() {
  const user = useUser();
  return hasPermission(user, 'alarm/update:add-comment');
}

export function useCanAddAlarmFeedback() {
  const user = useUser();
  return hasPermission(user, 'alarm/update:add-feedback');
}

export function useCanChangeAlarmStatus() {
  const user = useUser();
  return hasPermission(user, 'alarm/update:change-status');
}

export function useCanUpdateDcp() {
  const user = useUser();
  return hasPermission(user, 'dcp/details:update');
}

export function useCanAddDcp() {
  const user = useUser();
  return hasPermission(user, 'dcp:add');
}

export function useCanDebugMedia() {
  const user = useUser();
  return hasPermission(user, 'alarm/debug-media:view');
}

export function useCanViewLiveCamera() {
  const user = useUser();
  return hasPermission(user, 'camera/live:view');
}

export function useCanReportBug() {
  const user = useUser();
  return hasPermission(user, 'alarm/bug-report:create');
}

export function useCanAddLocation() {
  const user = useUser();
  return hasPermission(user, 'location:create');
}

export function useCanUpdateLocation() {
  const user = useUser();
  return hasPermission(user, 'location:update');
}

export function useCanViewLocationDetail() {
  const user = useUser();
  return hasPermission(user, 'location/detail:view');
}

export function useCanAddDoorGroup() {
  const user = useUser();
  return hasPermission(user, 'door_group:create');
}

export function useCanViewAlarmTypeGroup() {
  const user = useUser();
  return hasPermission(user, 'alarmtype_group:view');
}

export function useCanAddAlarmTypeGroup() {
  const user = useUser();
  return hasPermission(user, 'alarmtype_group:create');
}

export function useCanUpdateAlarmTypeGroup() {
  const user = useUser();
  return hasPermission(user, 'alarmtype_group:update');
}

export function useCanDeleteAlarmTypeGroup() {
  const user = useUser();
  return hasPermission(user, 'alarmtype_group:delete');
}

export function useCanUpdateUserAlarmTypeGroup() {
  const user = useUser();
  return hasPermission(user, 'user_alarmtype_group:update');
}

export function useCanUpdateDoorsToDoorGroup() {
  const user = useUser();
  return hasPermission(user, 'door/group:update');
}

export function useCanAddDoorsToLocation() {
  const user = useUser();
  return hasPermission(user, 'door/location:update');
}

export function useCanSeeDcpDetails() {
  const user = useUser();
  return hasPermission(user, 'dcp/details:view');
}

export function useCanRemoveMapping() {
  const user = useUser();
  return hasPermission(user, 'dcp:delete');
}

export function useCanViewTenantColumn() {
  const user = useUser();
  return hasPermission(user, 'multi-tenant:view');
}

export function useCanChangeStatusNoComment() {
  const user = useUser();
  return hasPermission(user, 'alarm/update:change-status-no-comment');
}

export function useCanVoiceCall() {
  const user = useUser();
  return hasPermission(user, 'voice-call');
}

export function useCanAddUser() {
  const user = useUser();
  return hasPermission(user, 'user:add');
}

export function useCanUpdateUser() {
  const user = useUser();
  return hasPermission(user, 'user:update');
}

export function useCanUpdateUserMSPLocations() {
  const user = useUser();
  return hasPermission(user, 'user/msp-locations:update');
}

export function useCanUpdateDeadZones() {
  const user = useUser();
  return hasPermission(user, 'camera:update/deadzone');
}

export function useCanUpdateVehicleParkingZone() {
  const user = useUser();
  return hasPermission(user, 'camera:update/vehicleparkingzone');
}

export function useCanUpdateActiveZone() {
  const user = useUser();
  return hasPermission(user, 'camera:update/activezone');
}

export function useCanUpdatePresenceZone() {
  const user = useUser();
  return hasPermission(user, 'camera:update/presencezone');
}

export function useCanUpdatePresenceRules() {
  const user = useUser();
  return hasPermission(user, 'tenant:update/presencerules');
}

export function useCanModifyAudioDevice() {
  const user = useUser();
  return hasPermission(user, 'audio_devices:modify');
}

export function useCanUpdateLocationAlarmStatus() {
  const user = useUser();
  return hasPermission(user, 'location_alarm:update');
}

export function useCanUpdateAlarmGroupStatus() {
  const user = useUser();
  return hasPermission(user, 'location_alarm/detail:view');
}

export function useCanShareLocationAlarm() {
  const user = useUser();
  return hasPermission(user, 'location_alarm/details:share');
}

export function useCanModifyAudioDeviceCamMap() {
  const user = useUser();
  return hasPermission(user, 'audio_devices/mappings:modify');
}

export function useCanUpdateTenantConfig() {
  const user = useUser();
  return hasPermission(user, 'tenant_config:update');
}

export function useCanUpdateArmedStatus() {
  const user = useUser();
  return hasPermission(user, 'camera:update/armed');
}

export function useCanUpdateCamera() {
  const user = useUser();
  return hasPermission(user, 'camera:update');
}

export function useCanAddCamera() {
  const user = useUser();
  return hasPermission(user, 'camera:add');
}

export function useCanUpdateCameraGroup() {
  const user = useUser();
  return hasPermission(user, 'camera_group:update');
}

export function useCanAddCameraGroup() {
  const user = useUser();
  return hasPermission(user, 'camera_group:create');
}

export function useCanViewCameraGroup() {
  const user = useUser();
  return hasPermission(user, 'camera_group:view');
}

export function useCanDeleteCameraGroup() {
  const user = useUser();
  return hasPermission(user, 'camera_group:delete');
}

export function useCanViewLocationAlarm() {
  const user = useUser();
  return hasPermission(user, 'location_alarm:view');
}

export function useCanUpdateSOP() {
  const user = useUser();
  return hasPermission(user, 'sop:update');
}
export function useCanUpdateAlarmNotifications() {
  const user = useUser();
  return hasPermission(user, 'alarm/notifications:update');
}

export function useCanUseAllTimeFilter() {
  const user = useUser();
  return hasPermission(user, 'filter:show-all-time');
}

export function useCanViewAlarmGroups() {
  const user = useUser();
  return hasPermission(user, 'alarm_group:view');
}

export function useCanViewAlarmGroupDetails() {
  const user = useUser();
  return hasPermission(user, 'alarm_group/detail:view');
}

export function useCanShareAlarmGroup() {
  const user = useUser();
  return hasPermission(user, 'alarm_group/details:share');
}

export function useCanViewPersonProfiles() {
  const user = useUser();
  return hasPermission(user, 'person_profiles:view');
}

export function useCanModifyPersonProfiles() {
  const user = useUser();
  return hasPermission(user, 'person_profiles:modify');
}

export function useCanCreateTenant() {
  const user = useUser();
  return hasPermission(user, 'tenants:create');
}

export function useCanUpdateTenant() {
  const user = useUser();
  return hasPermission(user, 'tenants:update');
}

export function useCanDeleteTenant() {
  const user = useUser();
  return hasPermission(user, 'tenants:delete');
}

export function useCanViewAppliances() {
  const user = useUser();
  return hasPermission(user, 'appliances:view');
}
